import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

export const FooterCopy = () => <>&copy; {new Date().getFullYear()} INaudio. All Rights Reserved.</>;

const Footer = () => {
    return (
        <footer className={classnames('site-footer')}>
            <div className="footer-content">
                <div className="footer-links">
                    <Link to="/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</Link>
                    <span className="separator">|</span>
                    <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
                </div>
                <div className="footer-copyright">
                    <small>
                        <FooterCopy />
                    </small>
                </div>
            </div>
        </footer>
    );
};
export default Footer;
